import { useTradingAgency } from '@models/TradingAgency';
import { createStrings } from '@utils/local';

export const tradingAgencyStrings = createStrings({
  ja: {
    UNKNOWN: 'わからない',
    USED: '利用する',
    UNUSED: '利用しない',
  },
});

export const tradingAgencyOptions = useTradingAgency.types.map((t) => ({
  value: t.value,
  label: tradingAgencyStrings[t.value],
}));
